import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import renderRoutes from 'libs/routes';
import 'moment/locale/zh-cn';
import './index.less';

moment.locale('zh-cn');

class Root extends React.Component {
  render() {
    return (
      <ConfigProvider
        locale={zhCN}
        getPopupContainer={node => {
          if (node) {
            return node.parentNode;
          }
          return document.body;
        }}
      >
        <Router>
          {renderRoutes('/')}
        </Router>
      </ConfigProvider>
    );
  }
}

export default Root;